/* eslint-disable */
import * as Types from '../../../../clients/graphqlTypes.js';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type OrganisationDetailsDataBox_ViewerOrganisationFragment = { __typename: 'ViewerOrganisation', id: string, title: string, description: string, organisationType: Types.OrganisationType, isCraftsmanOrganisation: boolean, email: any, website: string, phones: Array<{ __typename: 'Phone', id: string, main: boolean, type: Types.PhoneType, number: string }> };

export type OrganisationDetailsDataBox_ModifyOrganisationMutationVariables = Types.Exact<{
  input: Types.OrganisationUpdateInput;
}>;


export type OrganisationDetailsDataBox_ModifyOrganisationMutation = { updateOrganisation: { __typename: 'OrganisationUpdateResult', organisation: { __typename: 'ViewerOrganisation', id: string, title: string, description: string, email: any, website: string, organisationType: Types.OrganisationType, isCraftsmanOrganisation: boolean, phones: Array<{ __typename: 'Phone', id: string, number: string, type: Types.PhoneType, main: boolean }> } } };

export const OrganisationDetailsDataBox_ViewerOrganisationFragmentDoc = gql`
    fragment OrganisationDetailsDataBox_ViewerOrganisation on ViewerOrganisation {
  id
  title
  description
  organisationType
  isCraftsmanOrganisation
  email
  website
  phones {
    id
    main
    type
    number
  }
}
    `;
export const OrganisationDetailsDataBox_ModifyOrganisationDocument = gql`
    mutation OrganisationDetailsDataBox_ModifyOrganisation($input: OrganisationUpdateInput!) {
  updateOrganisation(input: $input) {
    organisation {
      id
      title
      description
      email
      website
      phones {
        id
        number
        type
        main
      }
      organisationType
      isCraftsmanOrganisation
    }
  }
}
    `;
export type OrganisationDetailsDataBox_ModifyOrganisationMutationFn = Apollo.MutationFunction<OrganisationDetailsDataBox_ModifyOrganisationMutation, OrganisationDetailsDataBox_ModifyOrganisationMutationVariables>;

/**
 * __useOrganisationDetailsDataBox_ModifyOrganisationMutation__
 *
 * To run a mutation, you first call `useOrganisationDetailsDataBox_ModifyOrganisationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrganisationDetailsDataBox_ModifyOrganisationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [organisationDetailsDataBoxModifyOrganisationMutation, { data, loading, error }] = useOrganisationDetailsDataBox_ModifyOrganisationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useOrganisationDetailsDataBox_ModifyOrganisationMutation(baseOptions?: Apollo.MutationHookOptions<OrganisationDetailsDataBox_ModifyOrganisationMutation, OrganisationDetailsDataBox_ModifyOrganisationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OrganisationDetailsDataBox_ModifyOrganisationMutation, OrganisationDetailsDataBox_ModifyOrganisationMutationVariables>(OrganisationDetailsDataBox_ModifyOrganisationDocument, options);
      }
export type OrganisationDetailsDataBox_ModifyOrganisationMutationHookResult = ReturnType<typeof useOrganisationDetailsDataBox_ModifyOrganisationMutation>;
export type OrganisationDetailsDataBox_ModifyOrganisationMutationResult = Apollo.MutationResult<OrganisationDetailsDataBox_ModifyOrganisationMutation>;
export type OrganisationDetailsDataBox_ModifyOrganisationMutationOptions = Apollo.BaseMutationOptions<OrganisationDetailsDataBox_ModifyOrganisationMutation, OrganisationDetailsDataBox_ModifyOrganisationMutationVariables>;